const sxStyles = ({ breakpoints, transitions }) => ({
    root: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        backgroundColor: "background.paper",
        color: "text.secondary",
        paddingTop: 2,
        paddingLeft: 8,
        paddingRight: 3,
        paddingBottom: 2,
        boxShadow: "0px -1px 2px rgba(0, 0, 0, 0.2)",
        transition: transitions.create(["padding-left"], {
            duration: transitions.duration.leavingScreen,
            delay: transitions.duration.complex,
        }),
        [breakpoints.up("xl")]: {
            transition: transitions.create(["padding-left"], {
                duration: transitions.duration.enteringScreen,
                delay: transitions.duration.shortest,
            }),
        },
    },
    logo: {
        width: "111px",
        height: "16px",
        display: "inline-block",
    },
    copyright: {
        fontSize: "12px",
    },
    text: {
        fontWeight: "400",
        fontSize: "14px",
        textTransform: "uppercase",
        color: "text.secondary",
    },
});
export default sxStyles;
//# sourceMappingURL=Footer.style.js.map